
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoaderActive: false,
}

export const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    triggerLoader: (state) => {
        state.isLoaderActive = !state.isLoaderActive;
    },
    showLoader: (state) => {
      state.isLoaderActive = true;
    },
    hideLoader: (state) => {
      state.isLoaderActive = false;
    },
  },
})

// Action creators are generated for each case reducer function
export const { triggerLoader, showLoader, hideLoader  } = loaderSlice.actions

export default loaderSlice.reducer